import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class ComunaService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerComunaSegunCodigo(inputParams: {
    entidad: {
      codigo: number
      nombre: string
      provincia_codigo: number
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: comunaInputType) {
          comuna {
            obtenerComunaSegunCodigo(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  provincia_codigo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.comuna.obtenerComunaSegunCodigo
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerDatosComunas(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query {
          comuna {
            obtenerSegunFiltro(
              filtro: {
                exacto: {
                  codigo: -1
                  provincia_codigo: -1
                  nombre: ""
                  codigo_region: -1
                }
              }
            ) {
              respuesta {
                registros {
                  codigo
                  nombre
                  provincia_codigo
                }
              }
            }
          }
        }
        `,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.comuna.obtenerSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerComunayVendedorConfirmacionNventa(inputParams: {
    rutEmpresa: number
    sucursalEmpresa: number
    paginaActual: number
    cantidadRegistrosPorPagina: number,
    soloAprobadosAnalisis: boolean
  }, callback: Function) {

    this.gqlclient.query(
      {
        query: gql`
        query ($rutEmpresa: Decimal, $sucursalEmpresa: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int, $soloAprobadosAnalisis: Boolean) {
          comuna {
            obtenerComunaSegunConfirmacionNotaVenta(rutEmpresa: $rutEmpresa, sucursalEmpresa: $sucursalEmpresa, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina, soloAprobadosAnalisis: $soloAprobadosAnalisis) {
              mensajes {
                codigo
                contexto
                texto
                tipo
                __typename
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  nombre
                  codigo_vendedor
                  vendedor_nombre
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.comuna.obtenerComunaSegunConfirmacionNotaVenta
        callback({ mensajes, respuesta })
      }
    );
  }

}
